export class PeriodoIngresoNavigation{
    periodoId: number;
    clave: string;
    tipoPeriodoId: number;
    institucionId: string;
    nombre: string;
    fechaInicio: Date;
    fechaFin: Date;
}